import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-20 px-4" data-id="element-98">
      <div className="max-w-4xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-gradient-to-br from-blue-900/40 to-purple-900/40 rounded-3xl p-8 md:p-12 border border-blue-500/30 overflow-hidden" data-id="element-100">
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/20 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2" data-id="element-101" />

          <div className="relative z-10" data-id="element-102">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-6 leading-tight" data-id="element-103">
              En los próximos 7 días, notarás algo diferente...
            </h3>
            <p className="text-lg md:text-xl text-blue-100 leading-relaxed font-medium" data-id="element-104">
              Tus costos por clic pueden subir ligeramente, pero la calidad de
              tus leads y ventas dará un salto cuántico. Al dejar de limitar al
              algoritmo con intereses falsos, permites que la IA de $500
              billones de dólares de Meta trabaje para ti, no en tu contra.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}